import './ImageTitle.css';
import { Link } from 'react-router-dom';

function ImageTitle({ titulo, paragrafo, disableButton }) {
  return (
    <section className="hero-section">
      <div className="hero-overlay"></div>
      <div className="container text-center hero-content">
        <h1 className="hero-title mb-3">{titulo}</h1>
        {paragrafo && <p className="hero-text d-none d-md-block mb-4">{paragrafo}</p>}
        {!disableButton && (
          <Link to={'/contatos'} className="btn btn-hero mt-3">
            Entre em Contato
          </Link>
        )}
      </div>
    </section>
  );
}

export default ImageTitle;